var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframeHolder",staticClass:"admin-view"},[(_vm.adminUrl)?_c('v-progress-circular',{staticClass:"admin-view__loader",attrs:{"indeterminate":"","color":"primary"}}):_c('div',{staticClass:"admin-view__loader"},[_vm._v("BAD ADMIN URL")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }